import { render, staticRenderFns } from "./DeleteLatestSalaryYearDialog.vue?vue&type=template&id=dae06718&scoped=true"
import script from "./DeleteLatestSalaryYearDialog.vue?vue&type=script&lang=js"
export * from "./DeleteLatestSalaryYearDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae06718",
  null
  
)

export default component.exports